// extracted by mini-css-extract-plugin
export default {"our_products":"OurProducts_our_products__XFc9k","btn":"OurProducts_btn__hm6jz"};